import type { StaffRole } from '@central/api';

interface NavItem {
  to: string;
  label: string;
  /** Only these roles see the section; every role when absent. */
  roles?: readonly StaffRole[];
}

/** Sidebar sections, in design order. */
export const navItems: readonly NavItem[] = [
  { to: '/', label: 'Overview' },
  { to: '/customers', label: 'Customers' },
  { to: '/licenses', label: 'Licenses' },
  { to: '/environments', label: 'Environments' },
  { to: '/inbox', label: 'Inbox' },
  { to: '/reports', label: 'Reports' },
  { to: '/announcements', label: 'Announcements' },
  { to: '/catalogue', label: 'Products & features' },
  { to: '/releases', label: 'Releases' },
  { to: '/logs', label: 'Logs' },
  { to: '/audit', label: 'Audit log' },
  { to: '/resellers', label: 'Resellers' },
  { to: '/staff', label: 'Staff & access' },
  { to: '/settings', label: 'Settings', roles: ['Owner', 'Admin'] },
];

/**
 * A reseller's sections: its overview, its customers, their environments,
 * its support inbox and report, the release installers, its team, and its
 * own account.
 */
export const resellerNavItems: readonly NavItem[] = [
  { to: '/partner', label: 'Overview' },
  { to: '/partner/customers', label: 'Customers' },
  { to: '/partner/environments', label: 'Environments' },
  { to: '/inbox', label: 'Support inbox' },
  { to: '/partner/reports', label: 'Reports' },
  { to: '/partner/releases', label: 'Releases & installers' },
  { to: '/partner/team', label: 'Team' },
  { to: '/staff', label: 'Your account' },
];

/** The paths a reseller may open; every other console page needs a Rethink role. */
export function resellerMayOpen(path: string): boolean {
  return (
    path === '/inbox' ||
    path.startsWith('/inbox/') ||
    path === '/staff' ||
    path === '/partner' ||
    path.startsWith('/partner/')
  );
}

/** The sections role sees. */
export function navFor(role: StaffRole): NavItem[] {
  if (role === 'Reseller') return [...resellerNavItems];
  return navItems.filter((n) => !n.roles || n.roles.includes(role));
}
